import axios from "axios";

function queryString(params = {}) {
    const query = Object.keys(params)
        .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== "")
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join("&");
    return query ? `?${query}` : "";
}

export function getProductListFun(params) {
    return axios.get(`/api/bms/product${queryString(params)}`).then((res) => res.data);
}

export function getProductDetailFun(id) {
    return axios.get(`/api/bms/product/${id}`).then((res) => res.data);
}

export function saveProductFun(data) {
    return data.productId
        ? axios.post("/api/bms/product/update", data).then((res) => res.data)
        : axios.post("/api/bms/product", data).then((res) => res.data);
}

export function updateProductStatusFun(id, status) {
    return axios.post(`/api/bms/product/${id}/status/${status}`).then((res) => res.data);
}

export function deleteProductFun(id) {
    return axios.post(`/api/bms/product/${id}/delete`).then((res) => res.data);
}


export function getDictOptionsFun(type) {
    return axios.get("/api/bms/dict/options?type=" + encodeURIComponent(type)).then((res) => res.data);
}
